import { useEffect, useRef } from "react"
import { Navigate, Outlet } from "react-router-dom"
import { useAuthStore } from "@/stores/auth-store"

export function ProtectedRoute() {
  const isAuthenticated = useAuthStore((state) => state.isAuthenticated)
  const isLoading = useAuthStore((state) => state.isLoading)
  const fetchUser = useAuthStore((state) => state.fetchUser)
  const hasFetched = useRef(false)

  useEffect(() => {
    if (!hasFetched.current) {
      hasFetched.current = true
      fetchUser()
    }
  }, [fetchUser])

  // Auth check still in progress — render layout + page (they handle their own loading)
  if (isLoading) {
    return <Outlet />
  }

  // Auth check done, not authenticated — redirect
  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />
  }

  return <Outlet />
}
